
import React from "react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { IntersectionIcon, UnionIcon } from "@/components/icons/BooleanLogicIcons";
import { 
  Tooltip, 
  TooltipContent, 
  TooltipProvider, 
  TooltipTrigger 
} from "@/components/ui/tooltip";

interface LogicToggleProps {
  value: "AND" | "OR";
  onChange: (value: "AND" | "OR") => void;
  className?: string;
  defaultValue?: "AND" | "OR";
}

const LogicToggle = ({ 
  value, 
  onChange, 
  className,
  defaultValue = "AND" 
}: LogicToggleProps) => {
  // Initialize with the default value if provided and no value is set
  React.useEffect(() => {
    if (defaultValue && !value) {
      onChange(defaultValue);
    }
  }, [defaultValue, value, onChange]);

  const toggleLogic = () => {
    console.log(`LogicToggle: toggling from ${value} to ${value === "AND" ? "OR" : "AND"}`);
    onChange(value === "AND" ? "OR" : "AND");
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="sm"
            className={cn("p-0", className)}
            onClick={toggleLogic}
            style={{ overflow: "visible" }}
          >
            {value === "AND" ? (
              // Intersection icon for AND logic
              <IntersectionIcon className="text-clustr-midGray" />
            ) : (
              // Union icon for OR logic
              <UnionIcon className="text-clustr-midGray" />
            )}
          </Button>
        </TooltipTrigger>
        <TooltipContent side="right">
          {value === "AND" 
            ? "AND logic: Content must have all selected tags" 
            : "OR logic: Content can have any of the selected tags"}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default LogicToggle;
